var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-expansion-panel', {
    staticClass: "side-list",
    class: `${_vm.color} lighten-5`
  }, [_c('v-expansion-panel-header', {
    staticClass: "side-list__title"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.content ? [_c('v-spacer'), _c('v-badge', _vm._b({
    staticClass: "side-list__badge",
    attrs: {
      "inline": ""
    }
  }, 'v-badge', {
    color: _vm.color,
    content: _vm.content
  }, false))] : _vm._e()], 2), _c('v-expansion-panel-content', [_c('v-row', {
    staticClass: "ma-n1"
  }, [_vm._l(_vm.types, function (type) {
    return [_c('v-col', {
      key: type,
      staticClass: "pa-1",
      attrs: {
        "cols": "12"
      }
    }, [_c('side-item', _vm._b({}, 'side-item', {
      side: _vm.side,
      type,
      items: _vm.items
    }, false))], 1)];
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }